import { DocxImportError } from 'containers/Tiptap/lib/import-utils';

export type ImportPhase = 'select' | 'importing' | 'failed';

export function stripDocxExtension(name: string): string {
  return name.replace(/\.docx$/i, '').trim() || 'Imported document';
}

// Actionable fallback when the file itself is likely the problem (Tiptap
// returned 4xx without a more specific code).
export const GENERIC_FILE_CAUSE =
  'The file may be password-protected, corrupted, or saved in an older Word format. Open it in Word and save it again as .docx, then try again.';

export const COULD_NOT_CREATE_MESSAGE = 'Could not create the new document. Check your connection and try again.';

export const IMPORT_TIMEOUT_MS = 90 * 1000;

export const IMPORT_TIMEOUT_MESSAGE = 'The import took too long and was stopped. Check your connection and try again.';

export function describeCause(error: unknown): string {
  if (error instanceof DocxImportError) {
    if (error.status === 401 || error.status === 403) {
      return "Your session doesn't have permission to convert documents. Refresh and try again.";
    }
    if (error.status === 413) {
      return 'The file is too large for the conversion service. Try a smaller .docx.';
    }
    if (error.status && error.status >= 500) {
      return 'The conversion service had a problem. Please try again in a moment.';
    }
    if (error.status && error.status >= 400) {
      // Tiptap rejected the file — usually means it can't read it.
      return GENERIC_FILE_CAUSE;
    }
    // No status → a failure we raised ourselves (network, create, missing
    // content). Surface the specific message rather than blaming the file.
    return error.message || GENERIC_FILE_CAUSE;
  }
  return GENERIC_FILE_CAUSE;
}
